import React from 'react'
import { string, object, oneOfType } from 'prop-types'
import { Message } from '@cobalt/cobalt-react-components'

const Error = ({ title, message }) => {
  if (!message) {
    return <React.Fragment />
  }

  return (
    <Message small danger block>
      {title ? <Message.Title>{title}</Message.Title> : <React.Fragment />}
      {message}
    </Message>
  )
}

Error.propTypes = {
  title: string,
  message: oneOfType([string, object])
}

export default Error
